<template>
    <div class="articleItem">
        <a :href="'/home/indexDetail/' + data.id" target="_blank">
            <div class="left" v-if="webCoverFileImg">
                <img :src="imgBaseUrl + webCoverFileImg.key" alt="">
            </div>
            <div class="right">
                <span class="title">{{data.bigTitle}}</span>
                <p>{{data.createTime | setTimeDate}}</p>
            </div>
        </a>
    </div>
</template>


<script>
    import api from '../../../../../../src/api'
    export default {
        data() {
            return {
                imgBaseUrl: api.common.imgBaseUrl
            }
        },
        props:{
            data: {
                type:Object
            },
            webCoverFileImg: {
                type:Object,
                default: {}
            }
        }
    }
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    .articleItem{
        width: 870px;
        height: 217px;
        margin-bottom: 20px;
        text-align: left;
        display: inline-block;
        cursor: pointer;
        .left{
            display: inline-block;
            width: 340px;
            height: 100%;
            text-align: center;
            vertical-align: top;
            background-color: rgb(235, 239, 240);
            img{
                width: 100%;
                vertical-align: middle;
                height: 100%;
                width: 100%;
                object-fit: cover;
            }
        }
        .right{
            display: inline-block;
            width: 506px;
            margin-left: 20px;
            text-align: left;
            vertical-align: top;
            margin-top: -7px;
            span{
                font-size: 20px;
                color: #353838;
                text-align: left;
                &:hover{
                    color:#308697;
                }
            }
            p{
                font-size: 14px;
                color: #6C6F70;
                margin-top: 5px;
                text-align: left;
                &:hover{
                    opacity: 0.8;
                }
            }
        }
    }
</style>